import { createAsyncThunk } from "@reduxjs/toolkit";
import toastHelper from "../../Util/toastHelper";
import API from "../../API/API";
import axios from "axios";

export const getPackageSubscriptionReports = createAsyncThunk(
  "reports/getPackageSubscriptionReports",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.packageSubscriptionReports.url,
        method: API.admin.packageSubscriptionReports.method,
      });

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getResidentReports = createAsyncThunk(
  "reports/getResidentReports",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.residentReports.url,
        method: API.admin.residentReports.method,
      });

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getProfitReport = createAsyncThunk(
  "reports/getProfitReport",
  async (
    params: {
      startDate: string;
      endDate: string;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.profitReport.url,
        method: API.admin.profitReport.method,
        params,
      });

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getBuildingMembersReport = createAsyncThunk(
  "reports/getBuildingMembersReport",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.buildingMembersReport.url,
        method: API.admin.buildingMembersReport.method,
      });

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getFutureBookingsReport = createAsyncThunk(
  "reports/getFutureBookingsReport",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAllFutureBookings.url,
        method: API.admin.getAllFutureBookings.method,
      });

      return data?.bookings ?? [];
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getPastBookingsReport = createAsyncThunk(
  "reports/getPastBookingsReport",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAllPastBookings.url,
        method: API.admin.getAllPastBookings.method,
      });

      return data ?? [];
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getDoorHistory = createAsyncThunk(
  "reports/getDoorHistory",
  async (params: { buildingId: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getDoorHistory.url + params.buildingId,
        method: API.admin.getDoorHistory.method,
      });

      return data ?? [];
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);
